export default "__VITE_ASSET__DXPHIsT$__"